module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v("\n    $\n    "), _c('input', {
    ref: "input",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "focus": _vm.selectAll,
      "blur": _vm.formatValue
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc360dd8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CurrencyInput.vue
// module id = 87
// module chunks = 1